export default __webpack_public_path__ + "static/media/6.849356e0.mp3";